function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 11.9996,
    cy: 9.0001,
    r: 7.15,
    fill: "#FEF0C7",
    style: {
      fill: "#FEF0C7",
      fill: "color(display-p3 0.9978 0.9393 0.7787)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.596 14.4773C18.0487 13.2584 18.9576 11.5123 19.1229 9.62326C19.2882 7.73418 18.6962 5.85682 17.4773 4.40417C16.2584 2.95152 14.5123 2.04258 12.6233 1.87731C10.7342 1.71203 8.85682 2.30396 7.40417 3.52288L12.0001 9.0001L16.596 14.4773Z",
    fill: "#FFD700",
    fillOpacity: 0.5,
    style: {
      fill: "#FFD700",
      fill: "color(display-p3 1.0000 0.8431 0.0000)",
      fillOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5963 19.7062L18.9675 14.0737C20.01 12.6487 20.625 10.8938 20.625 9C20.625 4.245 16.755 0.375 12 0.375C7.24502 0.375 3.37502 4.245 3.37502 9C3.37502 10.8938 3.99002 12.6487 5.03252 14.0737L2.40377 19.7062C2.28752 19.9575 2.31752 20.25 2.48627 20.4713C2.65127 20.6925 2.92502 20.805 3.19877 20.7638L6.71252 20.2275L8.56127 23.265C8.69627 23.49 8.94002 23.625 9.20252 23.625H9.24377C9.52127 23.61 9.76502 23.4412 9.88127 23.1937L12 18.6488L14.1188 23.1937C14.235 23.4412 14.4788 23.61 14.7563 23.625H14.7975C15.06 23.625 15.3038 23.49 15.4388 23.265L17.2875 20.2275L20.8013 20.7638C21.075 20.805 21.3488 20.6925 21.5138 20.4713C21.6825 20.25 21.7125 19.9575 21.5963 19.7062ZM12 16.125C8.07002 16.125 4.87502 12.93 4.87502 9C4.87502 5.07 8.07002 1.875 12 1.875C15.93 1.875 19.125 5.07 19.125 9C19.125 12.93 15.93 16.125 12 16.125Z",
    fill: "#FFD700",
    style: {
      fill: "#FFD700",
      fill: "color(display-p3 1.0000 0.8431 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3142 4.77273V13.5H11.9932V6.09375H11.9421L9.85401 7.45739V6.19602L12.0316 4.77273H13.3142Z",
    fill: "#C2A614",
    style: {
      fill: "#C2A614",
      fill: "color(display-p3 0.7598 0.6528 0.0776)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldBadge);
export default __webpack_public_path__ + "static/media/GoldBadge.0a9432e92355ea949d5a47ae7399384a.svg";
export { ForwardRef as ReactComponent };